<template>
  <div class="header d-flex justify-content-center col-sm-12">
    <div class="col-xs-12 text-center">
      <div class="negotiation-status">
        <slot name="status"></slot>
      </div>
    </div>

    <div class="row" style="width:1110px;">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "s-header",
  }
</script>
